import {
  LoadLatestSearchRequests,
  LoadPopularCategories,
  LoadPopularSearchRequests,
  LoadTrendingSearchRequests,
} from './mainpage.actions';

export const MainpageLoadingActions = [
  LoadLatestSearchRequests,
  LoadTrendingSearchRequests,
  LoadPopularCategories,
  LoadPopularSearchRequests,
];
